import { render, staticRenderFns } from "./c-technology-nfc-code-form.vue?vue&type=template&id=39820f26&scoped=true&"
import script from "./c-technology-nfc-code-form.vue?vue&type=script&lang=js&"
export * from "./c-technology-nfc-code-form.vue?vue&type=script&lang=js&"
import style0 from "./c-technology-nfc-code-form.vue?vue&type=style&index=0&id=39820f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39820f26",
  null
  
)

export default component.exports